import React from "react";
import { Switch } from "@heroui/react";

const CustomSwitch = ({ title, data }) => {
    return (
        <div className="flex flex-col">
            <div className="flex justify-between items-center">
                {/* Contenedor del texto */}
                <div className="flex flex-col gap-1">
                    <p className="text-small break-words">{title}</p>
                    {/* descomentar linea para descripcion adicional */}
                    {/* <p className="text-tiny text-default-400">BL/AWB</p> */}
                </div>

                {/* Switch */}
                <Switch isSelected={data} />
            </div>
        </div>
    );
};

export default CustomSwitch;